import { render, staticRenderFns } from "./projectMemoryBank.vue?vue&type=template&id=658b77ba&scoped=true&"
import script from "./projectMemoryBank.vue?vue&type=script&lang=js&"
export * from "./projectMemoryBank.vue?vue&type=script&lang=js&"
import style0 from "./projectMemoryBank.vue?vue&type=style&index=0&id=658b77ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658b77ba",
  null
  
)

export default component.exports